export class UpdateDto<T> {
  public key: Partial<T>;
  public filter: Partial<T>;

  constructor(key: Partial<T>, filter: Partial<T>) {
    this.key = key;
    this.filter = filter;
  }
}
